import axios from 'axios'

// ** Utils
// import { isUserLoggedIn } from '@utils'

// const initialUser = () => {
//   const item = window.localStorage.getItem('userData')
//   //** Parse stored json or if none return initialValue
//   return item ? JSON.parse(item) : {}
// }


const AxiosGet = async (url) => {
  try {
    // const userData = initialUser()
    // let percentCompleted = 0
    const config = {
      // headers: {
      //   Authorization: `Bearer ${userData['token']}`,
      //   'Content-Type': 'application/json'
      //   //, language: 'id-ID'
      // },
      // onUploadProgress: (progressEvent) => {
      //   percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
      // },
      timeout: 4000
    }
    const response = await axios.get(url, config)
    return response.data
      
  } catch (error) {
    return  error.response
  }
}

export default AxiosGet
